<template>
  <div
    class="
      tw-box-border
      tw-flex
      tw-shrink-0
      tw-items-center
      tw-justify-center
      tw-overflow-hidden
      tw-rounded-full
      tw-border
      tw-border-solid
      tw-border-[color:color-mix(in_srgb,var(--color-sky-darker,#0e7490)_20%,transparent)]
      tw-bg-sf-primary-subtle tw-shadow-sm
    "
    :class="sizeClasses"
  >
    <img
      v-if="hasPicture"
      :src="pictureUrl"
      :alt="name"
      class="tw-block tw-size-full tw-rounded-full tw-object-cover"
    />
    <span
      v-else
      class="tw-font-bold tw-text-sf-primary-darker"
      :class="initialsClasses"
    >
      {{ initials }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { UserAvatarSize } from './utils'
import { userInitials } from './utils'

interface Props {
  name: string
  pictureUrl?: string
  size?: UserAvatarSize
}

const props = withDefaults(defineProps<Props>(), {
  pictureUrl: '',
  size: 'md',
})

const SIZE_CLASSES: Record<UserAvatarSize, string> = {
  xsm: 'tw-size-6',
  sm: 'tw-size-7',
  md: 'tw-size-8',
  lg: 'tw-size-9',
}

const INITIALS_CLASSES: Record<UserAvatarSize, string> = {
  xsm: 'tw-text-[10px] tw-leading-5',
  sm: 'tw-text-xs tw-leading-[1.4]',
  md: 'tw-text-sm tw-leading-5',
  lg: 'tw-text-sm tw-leading-5',
}

const hasPicture = computed(() => Boolean(props.pictureUrl))
const sizeClasses = computed(() => SIZE_CLASSES[props.size])
const initialsClasses = computed(() => INITIALS_CLASSES[props.size])
const initials = computed(() => userInitials(props.name))
</script>
